export default {
  // route
  NEWSFEED_ALL: 'newsfeed:all:show',
  NEWSFEED_MINE: 'newsfeed:mine:show',
  NEWSFEED_IMPORTANT: 'newsfeed:important:show',
  NEWSFEED_LOCATION: 'newsfeed:location:show',
  NEWSFEED_SINGLE: 'newsfeed:single:show',

  NEWSFEED_EMPTY_STATE_TOGGLE: 'newsfeed:empty-state:toggle',
  NEWSFEED_RENDERALL: 'newsfeed:render-all',
  NEWSFEED_VIDEO: 'newsfeed:video',

  NEWSFEED_SHOW_CREATE_POST: 'newsfeed:show-create-post',
};
